/**
 * Required Scripts for page search
 *
 * @return {void}
 */
export const searchFormTips = () => {

	const searchInstances = document.querySelectorAll( '.js-search-form-tips' );

	if ( searchInstances.length > 0 ) {

		searchInstances.forEach( ( searchInstance ) => {

			visibleTrigger( searchInstance );
			getText( searchInstance );
			closeSearch( searchInstance );
			expandSearchInput( searchInstance )
			closeTipsByEsc( searchInstance )

		} );

	}

}

/**
 * Clear Search
 *
 * @param {HTMLElement} searchInstance
 *
 * @return {void}
 */
const clearSearch = ( searchInstance ) => {

	const searchInput = searchInstance.querySelector( '.js-search-form-input' );
	searchInput.value = '';
	searchInstance.classList.remove( 'c-search-form--show-tips', 'is-expanded' );

}

/**
 * Clear Search
 *
 * @param {HTMLElement} searchInstance
 *
 * @return {void}
 */
const expandSearchInput = ( searchInstance ) => {

	const searchInput = searchInstance.querySelector( '.js-search-form-input' );
	searchInput.addEventListener( 'focus', ( ) => {

		searchInstance.classList.add( 'is-expanded' )


	} )

}

/**
 * Open Tips Container
 *
 * @param {HTMLElement} searchInstance
 *
 * @return {void}
 */
const openTipsContainer = ( searchInstance ) => {

	const searchResults = searchInstance.querySelector( '.js-search-form-tips-results' );
	if ( searchResults.querySelector( '.c-search-form-tips__tip' ) ) {

		searchInstance.classList.add( 'c-search-form--show-tips' );

	}

}

/**
 * Close Tips Container
 *
 * @param {HTMLElement} searchInstance
 *
 * @return {void}
 */
const closeTipsContainer = ( searchInstance ) => {

	searchInstance.classList.remove( 'c-search-form--show-tips', 'is-expanded' );

}

/**
 * Close Tips Container when ESC presses
 *
 * @param {HTMLElement} searchInstance
 *
 * @return {void}
 */
const closeTipsByEsc = ( searchInstance ) => {

	document.addEventListener( 'keydown', ( event ) => {

		if ( searchInstance.classList.contains( 'c-search-form--show-tips' ) && event.key === 'Escape' ) {

			closeTipsContainer( searchInstance )
			closeSearch( searchInstance )

		}

	} )

}

/**
 * Search Filter
 *
 * @param {HTMLElement} searchInstance
 *
 * @return {void}
 */
const visibleTrigger = ( searchInstance ) => {

	document.addEventListener( 'click', ( event ) => {

		const isClickInside = searchInstance.contains( event.target )

		if ( !isClickInside ) {

			closeTipsContainer( searchInstance );

		}

	} )

}

/**
 * Close Search
 *
 * @param {HTMLElement} searchInstance
 *
 * @return {void}
 */
const closeSearch = ( searchInstance ) => {

	const closeButton = searchInstance.querySelector( '.js-close-search-button' )
	if ( !closeButton ) {

		return

	}
	closeButton.addEventListener( 'click', () => {

		closeTipsContainer( searchInstance );
		clearSearch( searchInstance )

	} )

}


/**
 * Get text
 *
 * @param {HTMLElement} searchInstance
 *
 * @return {void}
 */
const getText = ( searchInstance ) => {

	const searchInput = searchInstance.querySelector( '.js-search-form-input' );

	let resultsTimeOut = null;
	let searchQuery = '';

	if ( searchInput ) {

		searchInput.addEventListener( 'focus', ( e ) => {

			if ( e.target.value.length > 1 ) {

				openTipsContainer( searchInstance );

			}

		} );

		searchInput.addEventListener( 'input', ( e ) => {

			clearTimeout( resultsTimeOut );

			searchQuery = e.target.value.replace( /(<([^>]+)>)/ig, '' );
			if ( searchQuery.length > 1 ) {

				resultsTimeOut = setTimeout( () => {

					getResults( searchInstance, searchQuery );

				}, 300 );

			} else {

				searchInstance.classList.remove( 'c-search-form--show-tips' );

			}

		} );

	}

}

/**
 * Get Results
 *
 * @param {HTMLElement} searchInstance
 * @param {string} searchQuery
 *
 * @return {void}
 */
const getResults = ( searchInstance, searchQuery ) => {

	// Disable for global WP variables
	// eslint-disable-next-line no-undef
	const instanceVars = themeVars;

	const searchInput = searchInstance.querySelector( '.js-search-form-input' );
	const searchResults = searchInstance.querySelector( '.js-search-form-tips-results' );
	const formType = searchInstance.querySelector( '.js-search-form-type' );

	searchInstance.classList.add( 'c-search-form--loading' );

	fetch( instanceVars.ajaxUrl, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
		body: new URLSearchParams( {
			action: 'getSearchTips',
			bn: instanceVars.security,
			s: searchQuery,
			form_type: formType.value
		} ),
	} ).then( ( response ) => {


		return response.json();

	} ).then( ( response ) => {

		if ( searchInput.value === response.data.s ) {

			if ( response.data.results !== '' ) {

				searchResults.innerHTML = response.data.results;
				openTipsContainer( searchInstance );

			}


		}
		searchInstance.classList.remove( 'c-search-form--loading' );

	} ).catch( () => {

		searchInstance.classList.remove( 'c-search-form--loading' );

	} );

}
